import classNames from 'classnames';
import { UI_Container } from '../Container/Container';
import styles from './Main.module.scss';
import { SpeakerReadWrapper } from 'ui/components/1-atoms/Speaker/SpeakerReadWrapper';
export interface MainProps {
	breadCrumb?: React.ReactNode;
	children: React.ReactNode;
	header?: React.ReactNode;
	localNavigation?: React.ReactNode;
	localNavigationOnTop?: boolean;
	withLocalNavigationArticleWidth?: 'Standard' | 'Narrow';
	background?: 'bodyBackground' | 'bodyBackgroundContrast';
	speaker?: React.ReactNode;
}

export const UI_Main = ({
	breadCrumb,
	children,
	header,
	localNavigation,
	localNavigationOnTop,
	withLocalNavigationArticleWidth = 'Standard',
	background = 'bodyBackground',
	speaker,
}: MainProps) => {
	const defaultBackground = background == 'bodyBackground' || !background;
	return (
		<main
			id="main"
			className={classNames(
				styles.Main,
				localNavigation && styles.Main___withLocalNavigation,
				localNavigation && styles[`Main___withLocalNavigationArticleWidth${withLocalNavigationArticleWidth}`],
				localNavigation && localNavigationOnTop && styles.Main___localNavigationOnTop,
				defaultBackground ? 'u-background-default' : 'u-background-contrast',
			)}
		>
			{breadCrumb}
			{speaker}
			<SpeakerReadWrapper>
				{localNavigation ? (
					<UI_Container className={styles.Main_content} width="Standard">
						<article className={classNames(styles.Main_article, 'u-slim-content-width')}>
							{header}
							{children}
						</article>
						<div className={styles.Main_localNavigation}>{localNavigation}</div>
					</UI_Container>
				) : (
					<>
						{header}
						{children && <article className={classNames(styles.Main_article)}>{children}</article>}
					</>
				)}
			</SpeakerReadWrapper>
		</main>
	);
};
